import { SRGBColorSpace, TextureLoader, RepeatWrapping} from "three"


const texturesPath = {
    stickerCoffeeMap: '/stickers/coffee.png',
    stickerMeditationMap: '/stickers/meditation.png',
    stickerTenisMap:'/stickers/tenis.png',
    stickerConfiguratorMap: '/stickers/configurator.png',
    stickerSkullMap: '/stickers/skull.png',
    stickerKettleMap: '/stickers/kettle.png',
    note: '/stickers/note.png',
    groupBubblesDefault: '/textures/modelTextures/bubbles.webp',
    groupOneDefault: '/textures/modelTextures/variationOne/mapOne.webp',
    groupTwoDefault: '/textures/modelTextures/variationOne/mapTwo.webp',
    groupThreeDefault: '/textures/modelTextures/variationOne/mapThree.webp',
    groupFourDefault: '/textures/modelTextures/variationOne/mapFour.jpg',
    groupFiveDefault: '/textures/modelTextures/variationOne/mapFive.webp',
    groupOneSecond: '/textures/modelTextures/variationTwo/mapOne.webp',
    groupTwoSecond: '/textures/modelTextures/variationTwo/mapTwo.webp',
    groupThreeSecond: '/textures/modelTextures/variationTwo/mapThree.webp',
    groupFourSecond: '/textures/modelTextures/variationTwo/mapFour.jpg',
    groupFiveSecond: '/textures/modelTextures/variationTwo/mapFive.webp',
    perlinTexture: '/textures/perlin.png'
}

export const loadTextures = (loadingManager) =>{
    const textureLoader = new TextureLoader(loadingManager)
    const stickersMaps = {}
    const groupSecond = {}
    const groupDefault = {}
    let note = {}

    for(let key in texturesPath){
        const texture = textureLoader.load(texturesPath[key])
        texture.colorSpace = SRGBColorSpace
        texture.flipY = false

        if(key.includes('sticker')) stickersMaps[key] = texture
    
        if(key.includes('Default')) groupDefault[key] = texture
        
        if(key.includes('Second')) groupSecond[key] = texture
        
        if(key === 'note'){
            note = texture
            texture.flipY = true
        }

        if(key === 'perlinTexture') {
            groupDefault[key] = texture
            texture.wrapS = RepeatWrapping
            texture.wrapT = RepeatWrapping
            
        }
    }
   return { stickersMaps, note, groupDefault, groupSecond}
}

